import { findPathInTree } from "@/utils/findPathInTree";
import { useControllableValue } from "ahooks";
import { isArray, last } from "lodash";
import { useMemo } from "react";
import { HBCascader } from "../HBCascader";
import { useCrowdTags } from "./useCrowdTag";

/**
 * 行业选择器
 */
export function IndustrySelect(props) {
  const { industry: industries } = useCrowdTags();

  const [value, setValue] = useControllableValue(props, {
    defaultValue: [],
  });

  const cascaderValue = useMemo(() => {
    if (!industries?.length) {
      return [];
    }

    if (isArray(value)) {
      return value.map((v) => findPathInTree(industries, v));
    }
    return findPathInTree(industries, value) || [];
  }, [value, industries]);

  return (
    <HBCascader
      options={industries}
      value={cascaderValue}
      onChange={(value) => {
        setValue(value.map((v) => last(v)));
      }}
      multiple
      maxCount={3}
      placeholder={props.placeholder}
    />
  );
}
